"use client"

import { MapPin } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinIcon = component(Icon)({ as: MapPin })
